import Created from './Created';
import CreatorUser from './CreatorUser';
import Id from './Id';
import SourceStorage from './SourceStorage';
import Status from './Status';
import TargetStorage from './TargetStorage';

export const labels = {
  Id: 'Id',
  SourceStorage: 'Átadó raktár',
  TargetStorage: 'Átvevő raktár',
  Status: 'Status',
  CreatorUser: 'Létrehozta',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage'
}, {
  value: 'Status',
}, {
  value: 'CreatorUser'
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage'
}, {
  value: 'Status',
}, {
  value: 'CreatorUser'
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Id.propName,
  order: 'descending'
};

export default {
  Id,
  SourceStorage,
  TargetStorage,
  Status,
  CreatorUser,
  Created,
};
